module.exports = "ngb-pagination ::ng-deep ul > li:not(.active) > a {\n  background-color: white !important; }\n\nngb-pagination ::ng-deep ul > li.active > a {\n  background-color: #9b9b9b !important; }\n\nngb-pagination ::ng-deep .page-item.active .page-link {\n  border-color: lightgray;\n  background-color: #9b9b9b; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pagination-small/pagination-small.component.scss
// module id = ./src/app/shared/components/pagination-small/pagination-small.component.scss
// module chunks = main